import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { useTranslation } from '@/hooks/useTranslation';
import { useEffect, useRef, useState } from 'react';
import type { JSX } from 'react';

export function AdminRoute({ children }: { children: JSX.Element }) {
  const { isAuthenticated, isLoading, isAuthChecked, isRefreshingToken, isAdmin } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [isAdminValue, setIsAdminValue] = useState<boolean | null>(null);
  const hasChecked = useRef(false);

  useEffect(() => {
    if (!isAuthChecked || isRefreshingToken || hasChecked.current) return;
    hasChecked.current = true;
    isAdmin().then(setIsAdminValue);
  }, [isAuthChecked, isRefreshingToken, isAdmin]);

  useEffect(() => {
    if (!isLoading && isAdminValue === false) {
      if (import.meta.env.DEV) {
        console.log('Redirection to permission error page', isLoading, isAdminValue);
      }
      setShouldRedirect(true);
    }
  }, [isAuthChecked, isAuthenticated, isLoading, isAdminValue]);

  if (isLoading || isRefreshingToken || isAdminValue === null)
    return <div>{t('common.loading')}</div>;

  if (shouldRedirect) return <Navigate to="/permission-error" state={{ from: location }} />;

  return isAuthenticated ? children : null; // fallback: null while auth settles
}
